export default "__VITE_ASSET__d52463a2__"